<template>
    <v-container fluid>
        <!-- Título principal -->
        <v-row justify="center" class="mt-8 mb-2">
            <v-col cols="12" class="text-center">
                <h1 class="font-weight-bold display-1 mb-2">Visualización de Datos Básica</h1>
                <div class="subtitle-1 grey--text">Tablas, badges, tooltips y elementos de datos</div>
            </v-col>
        </v-row>

        <!-- Sección Tablas -->
        <v-row>
            <v-col cols="12">
                <h2 class="font-weight-bold mb-2">Tablas</h2>
                <v-card class="pa-6" outlined shaped>
                    <div>
                        <div class="font-weight-bold text-h5 mb-1">Proyectos de Sostenibilidad</div>
                        <div class="subtitle-2 grey--text mb-4">Estado actual de iniciativas ambientales</div>
                    </div>
                    <v-simple-table>
                        <thead>
                            <tr>
                                <th class="font-weight-bold">Proyecto</th>
                                <th class="font-weight-bold">Estado</th>
                                <th class="font-weight-bold">Progreso</th>
                                <th class="font-weight-bold">Impacto CO₂</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <v-chip color="deep-purple lighten-2" class="white--text mr-2" small>
                                        <v-icon left small>mdi-leaf</v-icon>
                                    </v-chip>
                                    Eficiencia Energética
                                </td>
                                <td>
                                    <v-chip color="green lighten-3" class="green--text text--darken-2" small>Activo</v-chip>
                                </td>
                                <td>
                                    <v-progress-linear value="85" color="deep-purple accent-2" height="8" rounded style="width: 80px; display: inline-block; vertical-align: middle;"></v-progress-linear>
                                    <span class="ml-2 grey--text text--darken-1">85%</span>
                                </td>
                                <td class="green--text text--darken-2 font-weight-medium">-1,234 kg</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card>
            </v-col>
        </v-row>

        <!-- Sección Badges y Estados -->
        <v-row class="mt-10">
            <v-col cols="12">
                <h2 class="font-weight-bold mb-4">Badges y Estados</h2>
            </v-col>
            <v-col cols="12" md="4">
                <v-card class="pa-5" outlined shaped style="background: #ffeaea; border-color: #ffbdbd;">
                    <div class="text-h5 font-weight-bold mb-2" style="color: #b71c1c;">Alto Riesgo</div>
                    <v-chip color="red lighten-1" class="white--text mb-3" small>
                        <v-icon left small>mdi-alert-circle</v-icon>
                        Crítico
                    </v-chip>
                    <v-card outlined class="pa-2" style="border-color: #ffbdbd; background: #fff6f6;">
                        <v-icon left small color="red darken-2">mdi-close-circle-outline</v-icon>
                        Emisiones superan límite crítico
                    </v-card>
                </v-card>
            </v-col>
            <v-col cols="12" md="4">
                <v-card class="pa-5" outlined shaped style="background: #fffbe6; border-color: #ffe082;">
                    <div class="text-h5 font-weight-bold mb-2" style="color: #b28900;">Riesgo Medio</div>
                    <v-chip color="yellow darken-2" class="white--text mb-3" small>
                        <v-icon left small>mdi-alert</v-icon>
                        Atención
                    </v-chip>
                    <v-card outlined class="pa-2" style="border-color: #ffe082; background: #fffde7;">
                        <v-icon left small color="yellow darken-2">mdi-alert-outline</v-icon>
                        Consumo cerca del límite mensual
                    </v-card>
                </v-card>
            </v-col>
            <v-col cols="12" md="4">
                <v-card class="pa-5" outlined shaped style="background: #eaffea; border-color: #b2f2bb;">
                    <div class="text-h5 font-weight-bold mb-2" style="color: #218838;">Bajo Riesgo</div>
                    <v-chip color="green" class="white--text mb-3" small>
                        <v-icon left small>mdi-check-circle</v-icon>
                        Óptimo
                    </v-chip>
                    <v-card outlined class="pa-2" style="border-color: #b2f2bb; background: #f6fff6;">
                        <v-icon left small color="green darken-2">mdi-check-circle-outline</v-icon>
                        Objetivos alcanzados exitosamente
                    </v-card>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "Visual"
};
</script>

<style scoped>
h1, h2 {
    font-family: 'Montserrat', 'Roboto', sans-serif;
}
</style>